import React from 'react';
import TableCell from "@mui/material/TableCell";
import {greyishBlue50} from "assets/jss/main";

function TableHeaderCell(props) {
    return (
        <TableCell
            sx={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#6b7280",
                textTransform: "uppercase",
                borderBottom: `1px solid ${greyishBlue50}`,
                padding: "12px 16px",
                backgroundColor: "#ffffff",
                ...props.sx
            }}
            {...props}
        >
            {props.children}
        </TableCell>
    )
}

export default TableHeaderCell;
